import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import DashboardReferrals from "../Pages/Dashboard/dashboardReferrals";
import DashboardProducts from "../Pages/Dashboard/dashboardProducts";
import DashboardLayout from "../Pages/Dashboard/dashboardLayout";
import MyDashboard from "../Pages/Dashboard/myDashboard";
import HelpAndSupport from "../Pages/Dashboard/helpAndSupport";
import MyAnalytics from "../Pages/Dashboard/MyAnalytics";
import VideoAnalytics from "../Pages/Dashboard/VideoAnalytics";

const ProtectedRoutes = () => {
  const [headerTitle, setHeaderTitle] = useState("");

  return (
    <Routes>
      <Route path="/" element={<DashboardLayout headerTitle={headerTitle} />}>
        <Route
          index
          element={
            <MyDashboard
              headerTitle={headerTitle}
              setHeaderTitle={setHeaderTitle}
            />
          }
        />
        <Route
          path="referrals"
          element={
            <DashboardReferrals
              headerTitle={headerTitle}
              setHeaderTitle={setHeaderTitle}
            />
          }
        />
        <Route
          path="myAnalytics"
          element={
            <MyAnalytics
              headerTitle={headerTitle}
              setHeaderTitle={setHeaderTitle}
            />
          }
        />
         <Route
          path="videoAnalytics/:id"
          element={
            <VideoAnalytics
              headerTitle={headerTitle}
              setHeaderTitle={setHeaderTitle}
            />
          }
        />
        <Route
          path="products"
          element={
            <DashboardProducts
              headerTitle={headerTitle}
              setHeaderTitle={setHeaderTitle}
            />
          }
        />
        <Route
          path="help"
          element={<HelpAndSupport setHeaderTitle={setHeaderTitle} />}
        />
        <Route
          path="*"
          element={<MyDashboard setHeaderTitle={setHeaderTitle} />}
        />
       
      </Route>
    </Routes>
  );
};

export default ProtectedRoutes;
